import '@fontsource-variable/inter'
import './styles/globals.css'

import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AppErrorBoundary } from '@/components/common/AppErrorBoundary'
import { retryUnlessClientError } from '@/lib/lookups'
import { initMonitoring } from '@/lib/monitoring'
import { purgeLegacySession } from '@/lib/session'
import { applyBrazilianValidationMessages } from '@/lib/validation'
import { Toaster } from '@/components/ui/sonner'
import { AuthProvider } from '@/providers/auth'
import { ChatNotificationsProvider } from '@/providers/chatNotifications'
import { ThemeProvider, migrateLegacyThemePreference } from '@/providers/theme'

initMonitoring()
applyBrazilianValidationMessages()

migrateLegacyThemePreference()
purgeLegacySession()

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: retryUnlessClientError } } })

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <ChatNotificationsProvider>
            <AppErrorBoundary>
              <App />
            </AppErrorBoundary>
            <Toaster richColors position="bottom-center" />
          </ChatNotificationsProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </QueryClientProvider>
)
